/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SigningAuthorizeSessionRequestDto
 */
export interface SigningAuthorizeSessionRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SigningAuthorizeSessionRequestDto
     */
    signingSessionId: string;
}

/**
 * Check if a given object implements the SigningAuthorizeSessionRequestDto interface.
 */
export function instanceOfSigningAuthorizeSessionRequestDto(value: object): value is SigningAuthorizeSessionRequestDto {
    if (!('signingSessionId' in value) || value['signingSessionId'] === undefined) return false;
    return true;
}

export function SigningAuthorizeSessionRequestDtoFromJSON(json: any): SigningAuthorizeSessionRequestDto {
    return SigningAuthorizeSessionRequestDtoFromJSONTyped(json, false);
}

export function SigningAuthorizeSessionRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SigningAuthorizeSessionRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'signingSessionId': json['signingSessionId'],
    };
}

export function SigningAuthorizeSessionRequestDtoToJSON(json: any): SigningAuthorizeSessionRequestDto {
    return SigningAuthorizeSessionRequestDtoToJSONTyped(json, false);
}

export function SigningAuthorizeSessionRequestDtoToJSONTyped(value?: SigningAuthorizeSessionRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'signingSessionId': value['signingSessionId'],
    };
}

